import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import './Navbar.css';
import { IconContext } from 'react-icons';
import { useSideC } from '../contexts/SidebarContext';

function Navbar() {
  const [sidebar, setSidebar] = useState(false);
  const {sidebarActive, disableSidebar, enableSidebar} = useSideC();



  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <div className='navbar'>
          <Link to='#' className='menu-bars'>
            <FaIcons.FaBars onClick={()=>{
                if(sidebarActive){
                  disableSidebar();
                }else{
                  enableSidebar();
                }
              }} />
          </Link>
        </div>
        <nav className={sidebarActive ? 'nav-menu active' : 'nav-menu'}>
          <ul className='nav-menu-items' onClick={()=>{
                if(sidebarActive){
                  disableSidebar();
                }else{
                  enableSidebar();
                }
              }}>
            <li className='navbar-toggle'>
              <Link to='#' className='menu-bars'>
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}
export default Navbar;

